import WarningModal from 'components/Modal/WarningModal';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';

export function RouterPromptMobile({ when }: { when: boolean }) {
  const history = useHistory();
  const [showPrompt, setShowPrompt] = useState(false);
  const [currentPath, setCurrentPath] = useState('');

  const unblockMobileRef = useRef<any>();

  function handleShowModal() {
    setShowPrompt(true);
  }

  function onCancel() {
    setShowPrompt(false);
  }

  useEffect(() => {
    unblockMobileRef.current = history.block((location) => {
      if (when) {
        setCurrentPath(location.pathname);
        handleShowModal();
        return false;
      }
      return true as any;
    });
    return () => {
      unblockMobileRef.current && unblockMobileRef.current();
    };
  }, [when]);

  function handleConfirm() {
    if (unblockMobileRef) {
      unblockMobileRef.current();
    }
    setShowPrompt(false);
    history.push(currentPath);
  }

  return showPrompt ? (
    <WarningModal
      isOpen={showPrompt}
      dataBody='You will lost changes before submit'
      btnAction='Continue'
      onClose={onCancel}
      onAction={handleConfirm}
      color='red'
    />
  ) : null;
}
